export default __webpack_public_path__ + "static/media/nomina_usuario.5f64cf16.png";